export const cellKey = (row, column) => `${row}:${column}`;

export const parseCellKey = (key) => key.split(':').map(Number);

export const isOnBoard = (size, row, column) => (
  row >= 0 && row < size && column >= 0 && column < size
);

